import Vue from 'vue'
import Router from 'vue-router'
import login from '../views/login/login.vue'

Vue.use(Router)
const router = new Router({
  scrollBehavior(to,from,savePosition){
    return{x:0,y:0}//滚动到顶部
  },
  routes: [
    {path: "/", redirect: '/login'},
  {
    path: '/login',
    name: 'login',
    meta:{
      title:'推荐有礼',
    },
    component: login
    },
  {
    path: '/login/:acticityId',
    name: 'login',
    meta:{
      title:'推荐有礼',
    },
    component: login
    },
  {
      path: '/activityInfo/:acticityId',
      name: 'activityInfo',
      meta:{
        title:'推荐有礼',
          needLogin:1
      },
      component: resolve=>require(['../views/activityInfo/activityInfo.vue'],resolve),
  },
  {
      path: '/progress',
      name: 'progress',
      meta:{
        title:'进度查询',
          needLogin:1
      },
      component: resolve=>require(['../views/progress/progress.vue'],resolve),
  },
  {
      path: '/errPage',
      name: 'errPage',
      meta:{
        title:'活动状态异常',
      },
      component: resolve=>require(['../views/errPage/errPage.vue'],resolve),
  }
  ]
});
export {
  router
}



// WEBPACK FOOTER //
// ./src/router/router.js